import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { QrcodeProcessPage } from './qrcode-process.page';

const routes: Routes = [
  {
    path: '',
    component: QrcodeProcessPage,
    children : [
      {
        path: 'owner',
        loadChildren: () => import('./owner/owner.module').then( m => m.OwnerPageModule)
      },
      {
        path: 'product',
        loadChildren: () => import('./product/product.module').then( m => m.ProductPageModule)
      },
      {
        path: 'transfer',
        loadChildren: () => import('./transfer/transfer.module').then( m => m.TransferPageModule)
      },
      {
        path: 'repeat',
        loadChildren: () => import('./repeat/repeat.module').then( m => m.RepeatPageModule)
      },
      {
        path: 'forbidden',
        loadChildren: () => import('./forbiden/forbiden.module').then( m => m.ForbidenPageModule)
      },
      {
        path: 'recover',
        loadChildren: () => import('./recover/recover.module').then( m => m.RecoverPageModule)
      },
      {
        path: 'professional-buy',
        loadChildren: () => import('./professional-buy/professional-buy.module').then( m => m.ProfessionalBuyPageModule)
      },
      {
        path: 'fnuci-product/:codeVente',
        loadChildren: () => import('./fnuci-product/fnuci-product.module').then( m => m.FnuciProductPageModule)
      },
      {
        path: 'force-transfer',
        loadChildren: () => import('./force-transfer/force-transfer.module').then( m => m.ForceTransferPageModule)
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class QrcodeProcessPageRoutingModule {}
